import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

export const TrackChangesDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  onApplyWithoutTracking: () => void;
  onConfirm: () => void;
}> = ({open, onClose, onApplyWithoutTracking, onConfirm}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Applying Amendments: Track changes not set.</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          Track Changes is not set to "Track changes for everyone". Do you want
          to enable this and continue applying amendments?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onApplyWithoutTracking} color="primary">
          Apply without tracking
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Apply with track changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const TrackChangesErrorDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  onApplyWithoutTracking: () => void;
}> = ({open, onClose, onApplyWithoutTracking}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>An error occurred.</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {
            'Could not enable "Track changes for everyone". Enable it in Word by going to Review > Track Changes > For Everyone, or continue to apply amendments without track changes enabled.'
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onApplyWithoutTracking} color="primary">
          Apply without tracking
        </Button>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
